module.exports = __webpack_public_path__ + "static/arcanaloth-2583faacf3c79276bb9f27b8b6c1a4f4.jpg";